import * as React from "react";
import EdButton from "../../../../generic/edButton";
import indexer from "../../../../types/genericTypes";
import Tag from "../../../../generic/tag";
import { ChipColorKeyComb, ChipStatusComb } from "../../obConstants";
import moment from "moment";
import { toINR } from "../../../../service/numberFormat";
import { IMF, IMFSip } from "../../../../types/components/orderBook/obTypes";
import { GetNoOfDaysOrMonths } from "../../../../service/dateTimeService";

export interface IObMfDtlContentProps<T> {
	data: T extends keyof IMFSip ? T : IMFSip extends keyof T ? T : any;
	onCancelClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const ObMfDtlContent: React.FC<IObMfDtlContentProps<IMF>> = (props) => {
	const MfTxnType: indexer = {
		FP: "Fresh Purchase",
		AP: "Add. Purchase",
		R: "Reedem",
		XSIP: "XSIP"
	};
	const OrdType: indexer = {
		FP: "Lumpsum",
		AP: "Lumpsum",
		R: "Lumpsum",
		XSIP: "SIP"
	};

	function onButtonClick(e: React.MouseEvent<HTMLButtonElement>) {
		console.log(e);
	}

	return (
		<div className="mf_detl_cont_wrap dtl_wrp">
			<div className="mf_info_row dtl_wrp_rw ">
				<div className="dtls_cont dtl_lft">
					<div className="dtl_lbl">
						<div className="dtl_hd taLeft">Amount/Units</div>
						<div className="dtl_amt taRight">{props.data.amount !== "0" ? "₹" + toINR(props.data.amount, 2) : props.data.units}</div>
					</div>
					<div className="dtl_lbl">
						<div className="dtl_hd taLeft">Action</div>
						<div className="dtl_amt taRight">{MfTxnType[props.data.txnType] || "--"}</div>
					</div>
				</div>
				<div className="dtls_cont dtl_right">
					<div className="dtl_lbl">
						<div className="dtl_hd taLeft">Order Type</div>
						<div className="dtl_amt taRight">{OrdType[props.data.txnType] || "--"}</div>
					</div>
					<div className="dtl_lbl">
						<div className="dtl_hd taLeft">Investment Type</div>
						<div className="dtl_amt taRight">{props.data.physicalFlag === "D" ? "Demat" : "Physical"}</div>
					</div>
				</div>
			</div>
			{/* if transection type XSIP need to show this block */}
			{props.data.txnType === "XSIP" && (
				<>
					<hr className="slim_line" />
					<div className="mf_info_row dtl_wrp_rw ">
						<div className="dtls_cont dtl_lft">
							<div className="dtl_lbl">
								<div className="dtl_hd taLeft">Frequency</div>
								<div className="dtl_amt taRight">{props.data.SIPFrequency || "--"}</div>
							</div>
							<div className="dtl_lbl">
								<div className="dtl_hd taLeft">Installments Paid</div>
								<div className="dtl_amt taRight">
									{GetNoOfDaysOrMonths(props.data.txnDate, props.data.startDate, props.data.SIPFrequency.toLowerCase() as string)}
								</div>
							</div>
							<div className="dtl_lbl">
								<div className="dtl_hd taLeft">Tenure</div>
								<div className="dtl_amt taRight">{props.data.tenure || "--"}</div>
							</div>
							<div className="dtl_lbl">
								<div className="dtl_hd taLeft">Start Date</div>
								<div className="dtl_amt taRight">
									{props.data.startDate ? moment(new Date(props.data.startDate)).format("D MMM YYYY") : "--"}
								</div>
							</div>
							<div className="dtl_lbl">
								<div className="dtl_hd taLeft">End Date</div>
								<div className="dtl_amt taRight">
									{props.data.endDate ? moment(new Date(props.data.endDate)).format("D MMM YYYY") : "--"}
								</div>
							</div>
						</div>
						<div className="dtls_cont dtl_right">
							<div className="dtl_lbl">
								<div className="dtl_hd taLeft">Mandate id</div>
								<div className="dtl_amt taRight">{props.data.mandateID || "--"}</div>
							</div>
							<div className="dtl_lbl">
								<div className="dtl_hd taLeft">Mandate Type</div>
								<div className="dtl_amt taRight">--</div>
							</div>
							<div className="dtl_lbl">
								<div className="dtl_hd taLeft">Mandate Status</div>
								<div className="dtl_amt taRight">
									{props.data.mandateSts ? (
										<Tag
											value={ChipStatusComb[props.data.mandateSts.toLowerCase()]}
											color={ChipColorKeyComb[props.data.mandateSts.toLowerCase()]}
										/>
									) : (
										"--"
									)}
								</div>
							</div>
							<div className="dtl_lbl">
								<div className="dtl_hd taLeft">SIP Registration No.</div>
								<div className="dtl_amt taRight">--</div>
							</div>
						</div>
					</div>
				</>
			)}
			<hr className="slim_line" />
			<div className="mf_info_row dtl_wrp_rw ">
				<div className="dtls_cont dtl_lft">
					<div className="dtl_lbl">
						<div className="dtl_hd taLeft">Scheme Category</div>
						<div className="dtl_amt taRight">--</div>
					</div>
					<div className="dtl_lbl">
						<div className="dtl_hd taLeft">Scheme Type</div>
						<div className="dtl_amt taRight">--</div>
					</div>
					<div className="dtl_lbl">
						<div className="dtl_hd taLeft">Exchange</div>
						<div className="dtl_amt taRight">--</div>
					</div>
				</div>
				<div className="dtls_cont dtl_right">
					<div className="dtl_lbl">
						<div className="dtl_hd taLeft">Return Type</div>
						<div className="dtl_amt taRight">--</div>
					</div>
					<div className="dtl_lbl">
						<div className="dtl_hd taLeft">Order Placed by</div>
						<div className="dtl_amt taRight tCC">{props.data.orderedBy || "--"}</div>
					</div>
				</div>
			</div>
			<hr className="slim_line" />
			{/* if transection type not  XSIP need to show this block */}
			{props.data.txnType !== "XSIP" && (
				<div className="mf_info_row dtl_wrp_rw ">
					<div className="dtls_cont dtl_lft">
						<div className="dtl_lbl">
							<div className="dtl_hd taLeft">Exchange Order No.</div>
							<div className="dtl_amt taRight">--</div>
						</div>
					</div>
					<div className="dtls_cont dtl_right">
						<div className="dtl_lbl">
							<div className="dtl_hd taLeft">ISIN No.</div>
							<div className="dtl_amt taRight">{props.data.ISIN || "--"}</div>
						</div>
					</div>
				</div>
			)}
			{/* if transection type XSIP need to show this block */}
			{props.data.txnType === "XSIP" && (
				<div className="mf_info_row dtl_wrp_rw ">
					<div className="dtls_cont dtl_lft">
						<div className="dtl_lbl">
							<div className="dtl_hd taLeft">Order No.</div>
							<div className="dtl_amt taRight">--</div>
						</div>
						<div className="dtl_lbl">
							<div className="dtl_hd taLeft">ISIN No.</div>
							<div className="dtl_amt taRight">{props.data.ISIN || "--"}</div>
						</div>
					</div>
					<div className="dtls_cont dtl_right">
						<div className="dtl_lbl">
							<div className="dtl_hd taLeft">Exchange Order No.</div>
							<div className="dtl_amt taRight">--</div>
						</div>
					</div>
				</div>
			)}
			{/* buttons to perform different actions on click */}
			{!props.data.history && (
				<div className="ob_btns btn_wrapper mg-t20 mg-b50">
					<div className="btn_left">
						{/* button to cancel */}
						{props.data.isCancel && (
							<EdButton value="Cancel Order" btnTyp="secondary" onClick={props.onCancelClick} className="mg-r20" slim />
						)}
						{/* button to modify */}

						{props.data.isModify && <EdButton value="Modify Order" btnTyp="secondary" onClick={onButtonClick} slim />}
					</div>
				</div>
			)}
		</div>
	);
};

export default ObMfDtlContent;
